export class UpdateInitialDataPhase {
    constructor({
        chECFase_c = null,
        tPerDistrito_c = null,
        tPerProvincia_c = null,
        tPerDepartamento_c = null,
        nHogarMetros_c = null,
    } = {}) {
        this.chECFase_c = chECFase_c;
        this.tPerDistrito_c = tPerDistrito_c;
        this.tPerProvincia_c = tPerProvincia_c;
        this.tPerDepartamento_c = tPerDepartamento_c;
        this.nHogarMetros_c = nHogarMetros_c;
    }
}

export class UpdateQuotePhase {
    constructor({
        chECFase_c = null,
        cHogarValorBienes_c = null,
        cHogarValorInmueble_c = null,
        dECInicio_c = null
    } = {}) {
        this.chECFase_c = chECFase_c;
        this.cHogarValorBienes_c = cHogarValorBienes_c;
        this.cHogarValorInmueble_c = cHogarValorInmueble_c;
        this.dECInicio_c = dECInicio_c;
    }
}

export class UpdateDataPhase {
    constructor({
        chECFase_c = null,
        nHogarAntiguedad_c = null,
        nHogarNumPisos_c = null,
        nHogarNumSotanos_c = null,
        tHogarMaterialConstruccion_c = null,
        tPerDireccion_c = null,
        tPerInterior_c = null
    }) {
        this.chECFase_c = chECFase_c
        this.nHogarAntiguedad_c = nHogarAntiguedad_c
        this.nHogarNumPisos_c = nHogarNumPisos_c
        this.nHogarNumSotanos_c = nHogarNumSotanos_c
        this.tHogarMaterialConstruccion_c = tHogarMaterialConstruccion_c
        this.tPerDireccion_c = tPerDireccion_c
        this.tPerInterior_c = tPerInterior_c
    }
}
export class UpdatePaymentPhase {
    constructor({ chECFase_c = null }) {
        this.chECFase_c = chECFase_c;
    }
}


export class UpdateEndPhase {
    constructor({ chECFase_c = null, tECNumPoliza_c = null }) {
        this.chECFase_c = chECFase_c;
        this.tECNumPoliza_c = tECNumPoliza_c;

    }
}